// @core/api/endpoints/platform/disable_platform_product.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DisablePlatformProductRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Disable product on platform
 * Removes a product from platform availability. Existing tenant subscriptions remain active but no new subscriptions are allowed.
 */
export async function DisablePlatformProduct(
  platform_id: string,
  product_id: string,
  data: DisablePlatformProductRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/products/:product_id/disable`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
